import { WaitAction } from 'react-aquasys'
import fetch from 'isomorphic-fetch'
import { checkStatus, getJson } from '../../utils/ActionUtils'
import ApplicationConf from '../../conf/ApplicationConf'
import { RECEIVE_POINT, RECEIVE_POINT_KEY_FIGURES, RECEIVE_POINT_NETWORKS, RECEIVE_SAMPLING_SURFACE_POINT, RESET_POINT_INFORMATIONS } from '../constants/PointConstants'
import SiteTypes from '../../utils/mapUtils/SiteTypes'
import { getFetchSiteIds } from '../../utils/ApplicationUtils'
import i18n from 'simple-react-i18n'
import ToastrAction from '../../home/actions/ToastrAction'

const PointAction = {

	receivePoint: function (point) {
		return {
			type: RECEIVE_POINT,
			point: point
		}
	},
	fetchPoint: function (id) {
		return function (dispatch) {
			dispatch(WaitAction.waitStart())
			return fetch(ApplicationConf.point.getDetailPoint(), {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({
					idpoint: id
				})
			})
				.then(getJson)
				.then((json = []) => {
					if (!json.error && json.length) {
						dispatch(PointAction.receivePoint(json[0]))
						dispatch(PointAction.fetchPointKeyFigures(json[0].id))
						dispatch(PointAction.fetchPointNetworks(json[0].id))
						return json
					}
					return undefined
				}).then((json) => {
					dispatch(PointAction.prepareFetchType(json))
				}).then(() => {
					dispatch(WaitAction.waitStop())
				})
		}
	},
	receivePointKeyFigures: function (pointKeyFigures) {
		return {
			type: RECEIVE_POINT_KEY_FIGURES,
			pointKeyFigures: pointKeyFigures
		}
	},
	fetchPointKeyFigures: function (id) {
		return function (dispatch) {
			dispatch(WaitAction.waitStart())
			return fetch(ApplicationConf.sites.getKeyFigures(), {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(
					{
						stationids: getFetchSiteIds([id])
					})
			})
				.then(response => checkStatus({
					200: ((rep) => rep.json()),
					204: (() => []),
					404: (() => [])
				}, response))
				.then((json = []) => {
					if (json.length) {
						dispatch(PointAction.receivePointKeyFigures(json))
					}
					return []
				})
		}
	},

	receivePointNetworks: function (pointNetworks) {
		return {
			type: RECEIVE_POINT_NETWORKS,
			pointNetworks: pointNetworks
		}
	},

	fetchPointNetworks: function (id) {
		return function (dispatch) {
			dispatch(WaitAction.waitStart())
			return fetch(ApplicationConf.station.getNetworks(), {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(
					{
						idstation: id
					})
			})
				.then(response => checkStatus({
					200: ((rep) => rep.json()),
					204: (() => []),
					404: (() => [])
				}, response))
				.then((json = []) => {
					dispatch(PointAction.receivePointNetworks(json))
				}).then(() => {
					dispatch(WaitAction.waitStop())
				})
				.catch(() => {
					dispatch(ToastrAction.error(i18n.error.errorLoadingData))
					dispatch(WaitAction.waitStop())
				})
		}
	},
	prepareFetchType: function (json) {
		if (json) {
			const point = json[0]
			return function (dispatch) {
				switch (point.typeparameter) {
					case SiteTypes.QUALITOMETER.type:
					case SiteTypes.QUALITOMETER_SURFACE.type:
						return dispatch(PointAction.fetchQualitometer(point.id))
					default:
						return ''
				}
			}
		}
		return ''
	},

	fetchQualitometer: function (id) {
		return function (dispatch) {
			dispatch(PointAction.fetchSamplingSurfacePoint(id))
		}
	},
	receiveSamplingSurfacePoint: function (samplingSurfacePoints) {
		return {
			type: RECEIVE_SAMPLING_SURFACE_POINT,
			samplingSurfacePoints: samplingSurfacePoints
		}
	},
	fetchSamplingSurfacePoint: function (id) {
		return function (dispatch) {
			return fetch(ApplicationConf.station.getSamplingSurfacePoints(), {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(
					{
						idpoint: id
					})
			})
				.then(response => checkStatus({
					200: ((rep) => rep.json()),
					204: (() => []),
					404: (() => [])
				}, response))
				.then((json = []) => {
					dispatch(PointAction.receiveSamplingSurfacePoint(json))
				})
				.catch(() => {
					dispatch(ToastrAction.error(i18n.error.errorLoadingData))
					dispatch(WaitAction.waitStop())
				})
		}
	},
	reset: function () {
		return {
			type: RESET_POINT_INFORMATIONS
		}
	}
}
export default PointAction



// WEBPACK FOOTER //
// ./src/point/actions/PointAction.js